import React, { useEffect } from 'react';
import style from './StickyCallNowBannerStyles.css';

const StickyCallNowBanner = () => {
  useEffect(() => {
    // US579842 - scroll listener to trigger sticky banner
    const element = document.getElementById('stickyBannerContainer');
    const triggerStickyOnScroll = () =>
      window.scrollY >= 100 && element?.classList.add('sticky');
    window.addEventListener('scroll', triggerStickyOnScroll);
    return () => window.removeEventListener('scroll', triggerStickyOnScroll);
  }, []);

  return (
    <>
      <div id="stickyBannerContainer" className="sticky-banner-container">
        <div className="sticky-banner-content">
          <div className="stick-banner-child-one">
            <p>
              <span>Let&apos;s find an account that&apos;s right for you.</span>
              <br />
              <span>
                {' '}
                Questions? Call a Financial Consultant at{' '}
                <a href="tel:1-855-793-6611">1-855-793-6611</a>.
              </span>
            </p>
          </div>
          <div className="stick-banner-child-two">
            <a href="tel:1-855-793-6611">Call Now</a>
          </div>
        </div>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default StickyCallNowBanner;
